// frontend bundle entry
// imports are explicit, so adding a post format means adding a line here
// stylesheet order is the concatenation order, keep it alphabetical to match
// what the old glob produced
import '../scss/frontend/audio.scss';
import '../scss/frontend/common.scss';
import '../scss/frontend/gallery.scss';
import '../scss/frontend/link.scss';
import '../scss/frontend/quote.scss';
import '../scss/frontend/video.scss';

import * as common from './frontend/common.js';
import * as gallery from './frontend/gallery.js';

// modules only expose idempotent init functions, this entry owns every global,
// so there is one dom ready, one observer and one resize handler for the bundle
const init = function () {
	common.init();
	gallery.init();
};

// call init on dom ready, bundle is enqueued in the footer so it can already be past
if ( 'loading' === document.readyState ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}

// call init again for posts loaded in later
// watching dom covers any loader, jquery ajaxComplete only fired for jquery requests
// gallery holders carry .bpf-content too, so one observer feeds both modules
// attributes are not watched, so classes and heights set by init don't come back around
const reload = new MutationObserver(
	function ( mutations ) {
		const hasNewContent = mutations.some(
			function ( mutation ) {
				return Array.prototype.some.call(
					mutation.addedNodes,
					function ( node ) {
						return node.nodeType === Node.ELEMENT_NODE &&
							( node.matches( '.bpf-content' ) || node.querySelector( '.bpf-content' ) );
					}
				);
			}
		);

		if ( hasNewContent ) {
			init();
		}
	}
);

reload.observe( document.documentElement, { childList: true, subtree: true } );

// keep oembed iframes in ratio, run once per frame for bursts of resize events
let resizeFrame = null;

window.addEventListener(
	'resize',
	function () {
		if ( resizeFrame ) {
			return;
		}

		resizeFrame = window.requestAnimationFrame(
			function () {
				resizeFrame = null;

				common.resizeIFrames();
			}
		);
	}
);
